import { Component } from 'opus-angular-seed-core';
import { Loader } from '@googlemaps/js-api-loader';

@Component({
    bindings: {
        place: '=',
        defaultValue: '='
    },
    template: `
        <div class="google">
            <div class="google-form">
                <input placeholder="{{ 'google.places.Search by name or address...' | translate  }}" type="text" id="pac-input" ng-model="vm.defaultValue">
            </div>
        </div>
    `
})
export default class {
    constructor (lodash, $scope) {
        this.lodash = lodash;
        this.$scope = $scope;

        this.loader = new Loader({
            apiKey: SEED_CORE.ENV.GOOGLE_MAPS_API_KEY,
            version: 'weekly',
            libraries: ['places']
        });
    }

    $onInit () {
        this.loader.importLibrary('places').then((places) => {
            const input = document.getElementById('pac-input');
            const searchBox = new places.SearchBox(input);

            // prevent enter key submitting if there are any google dom nodes visible
            searchBox.addListener('places_changed', () => {
                const placesArray = searchBox.getPlaces();
                this.$scope.$apply(() => this.updatePlace(this.lodash.first(placesArray)));
            });
        });
    }

    updatePlace (place) {
        if (place) {
            this.place = place;
        }
        else {
            this.place = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/googlePlaces/index.js